module.exports = __webpack_public_path__ + "img/scissors.d8e8b827.svg";